export const statusMapping = new Map([
  ['status.card.active', 'success'],
  ['status.card.invited', 'warning'],
  ['status.card.blocked', 'danger'],
  ['status.card.canceled', 'danger'],
  ['status.card.done', 'success'],
  ['status.card.accepted', 'success'],
  ['status.card.cleared', 'warning'],
  ['status.card.declined', 'danger'],
  ['status.card.settled', 'settled'],
  ['status.card.removed', 'info'],
  ['status.card.reversed', 'info'],
  ['status.card.activeCard', 'success'],
  ['status.card.blockedCard', 'warning'],
  ['status.card.closedCard', 'danger'],
  ['status.card.failed', 'danger'],
  ['status.card.inProgress', 'info'],

  // Wallet statuses
  ['status.wallet.created', 'warning'],
  ['status.wallet.progress', 'info'],
  ['status.wallet.success', 'success'],
  ['status.wallet.paid', 'success'],
  ['status.wallet.paidError', 'danger'],
  ['status.wallet.failed', 'danger'],
  ['status.wallet.inProgress', 'info'],
  ['status.wallet.estimation', 'info'],
  ['status.wallet.waiting-topup', 'info'],
  ['status.wallet.waiting-hash', 'warning'],
  ['status.wallet.onHold', 'warning'],
  ['status.wallet.completed', 'success'],
  ['status.wallet.done', 'success'],
  ['status.wallet.rejected', 'danger'],
  ['status.wallet.created', 'default'],
  ['status.wallet.canceled', 'danger'],
  ['status.wallet.cancelled', 'danger'],

  // Account statuses
  ['active', 'success'],
  ['blocked', 'danger'],
  ['waiting for email approve', 'warning'],
  ['waiting for phone approve', 'warning'],
  ['waiting for enter data', 'warning'],
  ['waiting for account approve', 'warning'],
  ['invite sent', 'info'],
  ['Approval required', 'info'],
]);
